import apiClient from "./client";

/**
 * Subscription & Self-Service API
 */
export const subscriptionApi = {
  /**
   * Self-service signup (public, no auth required)
   */
  signup: (data) => {
    return apiClient.post("/subscription/signup", data);
  },

  /**
   * Get current tenant's subscription details
   */
  getCurrent: () => {
    return apiClient.get("/subscription/current");
  },

  /**
   * Get feature flags for current tenant
   */
  getFeatures: () => {
    return apiClient.get("/subscription/features");
  },

  /**
   * Update tenant region
   */
  updateRegion: (region) => {
    return apiClient.put("/subscription/region", { region });
  },

  /**
   * Upgrade to Pro tier
   */
  upgradeToPro: () => {
    return apiClient.post("/subscription/upgrade");
  },

  /**
   * Get pricing data (public, no auth required)
   */
  getPricing: (region = null) => {
    const params = region ? `?region=${region}` : "";
    return apiClient.get(`/subscription/pricing${params}`);
  },
};

export default subscriptionApi;
